import { Box, LinearProgress, linearProgressClasses } from "@mui/material";
import { styled } from "@mui/material/styles";
import { gray } from "configs/colors";
import { lineHeight, rem } from "utils";

import { BarProgressProps, CircleProgressProps } from "./Progress.types";
import Typography from "../../atoms/Typography";

export const BarContainer = styled(Box)<Pick<BarProgressProps, "placement">>(
  ({ placement }) => {
    let styleBasedOnPlacement = {};
    switch (placement) {
      case "right-center": {
        styleBasedOnPlacement = {
          display: "flex",
          alignItems: "center",
          gap: rem(12),

          "& .MuiLinearProgress-root": {
            flex: 1,
          },
          "& .progress-value": {
            flex: "0 0 auto",
          },
        };
        break;
      }
      case "bottom-right": {
        styleBasedOnPlacement = {
          display: "block",
          "& .progress-value": {
            textAlign: "right",
            marginTop: rem(8),
          },
        };
        break;
      }
      case "hover": {
        styleBasedOnPlacement = {
          display: "block",
        };
        break;
      }
      default: {
        styleBasedOnPlacement = {
          display: "block",
        };
        break;
      }
    }
    return {
      width: "100%",
      ...styleBasedOnPlacement,
    };
  }
);

export const BarProgress = styled(LinearProgress)(({ color, theme }) => {
  const colorPalette = {
    background: gray[200],
    color: theme.palette[(color === "inherit" ? "grey" : color) as never][600],
  };
  return {
    height: rem(8),
    borderRadius: "4px",
    background: colorPalette.background,
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: colorPalette.color,
    },
    "&.MuiLinearProgress-colorInherit:before": {
      display: "none",
    },
  };
});

export const BarValueWrapper = styled(Box)(() => ({
  minWidth: rem(37),
}));

export const CircleContainer = styled(Box)(() => ({
  position: "relative",
  display: "inline-flex",
}));

export const CircleValueWrapper = styled(Typography)<
  Pick<CircleProgressProps, "size">
>(({ size }) => {
  let styleBasedOnSize = {};
  switch (size) {
    case "xxs": {
      styleBasedOnSize = {
        fontSize: rem(14),
        lineHeight: lineHeight(20),
      };
      break;
    }
    case "xs": {
      styleBasedOnSize = {
        fontSize: rem(24),
        lineHeight: lineHeight(32),
      };
      break;
    }
    case "sm": {
      styleBasedOnSize = {
        fontSize: rem(30),
        lineHeight: lineHeight(38),
      };
      break;
    }
    case "md": {
      styleBasedOnSize = {
        fontSize: rem(36),
        lineHeight: lineHeight(44),
        letterSpacing: "-0.72px",
      };
      break;
    }
    case "lg": {
      styleBasedOnSize = {
        fontSize: rem(48),
        lineHeight: lineHeight(60),
        letterSpacing: "-0.96px",
      };
      break;
    }
    default:
      break;
  }
  return {
    position: "absolute",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    fontWeight: 500,
    width: "max-content",
    zIndex: 2,
    ...styleBasedOnSize,
  };
});
